export const principles = [
  "The best technical solution is the one that solves the business problem.",
  "Clear communication can rescue a complicated project.",
  "You should understand a system before trying to automate it.",
  "Relationships matter as much as architecture.",
  "Being able to do the work makes you better at managing the work.",
  "Problems rarely respect job descriptions.",
  "Most things can be figured out by asking better questions.",
  "Build something useful before building something impressive.",
  "Work hard, be honest, and do not become impossible to work with."
];
